



































































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    name: "InputCheckboxGroup",
    props: {
        checkboxes: {
            type: Array,
            required: true,
            default: [] as Array<string>
        },
        ariaLabelTooltip: {
            type: String,
            required: false,
            default: ""
        },
        inputLabel: {
            type: String,
            required: true
        },
        inputDescription: {
            type: String,
            required: false,
            default: ""
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: true
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        inputTooltip: {
            type: Boolean,
            required: false,
            default: false
        },
        valuesChecked: {
            type: Array,
            required: false,
            default: () => []
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type: String,
            required: false,
            default: ""
        },
        specificId: {
            type: String,
            required: false,
            default: ""
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        noMargin: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            uniqueId: (this.specificId !== "") ? this.specificId : uuidv4() as string,
            errors: [] as Array<string>
        };
    },

    computed: {
        selectedValues: {
            get: function(): string[] {
                return this.valuesChecked as string[];
            },
            set: function(value: string[]) {
                this.$emit("update-value", value);
            }
        }
    },
    methods: {
        checkForm: function() {
            if(this.required) {
                this.errors.push(`${this.name} is required ! Please check it`);
            }
        },
    }
});
